import { ResponseStatusEnum } from '../../enums/ResponseStatus';

const getErrorObjects = (messages: any[]) => messages.map((message) => {
    // default prop
    if (message.constraints) {
        return {
            [message.property]: Object.values(message.constraints).join(' '),
        };
    }

    // nested props

    // class-validator sets message property to numeric string
    // have to research and do changes in backend, maybe then there is no need to check isNaN
    if (isNaN(message.property)) {
        return {
            [message.property]: getErrorObjects(message.children),
        };
    }
    // errors have to be differentiated, so the value is added into the object
    if (message.value) {
        return {
            value: message.value,
            errors: Object.assign({}, ...getErrorObjects(message.children)),
        };
    }
    // there is still no valid property or value
    return getErrorObjects(message.children);
});

export const extractErrors = (result) => {
    if (result?.status !== ResponseStatusEnum.badRequest) {
        return undefined;
    }
    const errorObjects = getErrorObjects(result.body.message);
    return Object.assign({}, ...errorObjects);
};

export const extractStatusErrors = (result) => {
    if (result.statusCode === ResponseStatusEnum.badRequest) {
        const errorObjects = getErrorObjects(result.message);
        return Object.assign({}, ...errorObjects);
    }
    return undefined;
};
